// Images shown when the ems_banner_image_url Statsig parameter is unset or empty
export const ANONYMOUS_ES_BANNER_IMAGE = '/images/es-cta-graphic.png';
export const LOGGED_IN_ES_BANNER_IMAGE = '/images/email-sync-banner-device.png';
